module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("1. Temple of Venus Genetrix, Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("The Temple of Venus Genetrix (the ‘universal mother’) in the Forum of Julius Caesar. The present remains date to the reign of Trajan ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 98–117) but the original structure was dedicated by Caesar in 46 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(" in thanks for his victory at Thessaly two years earlier. The building commemorated the Julian family’s claimed descent from Venus through her son Aeneas. It also contained a statue of Cleopatra VII, installed by Caesar.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("2. Tomb of Caecilia Metella, Via Appia")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("The drum-shaped late Republican tomb of Caecilia Metella on the Via Appia bears this inscription which clearly indicates her role as a dynastic commodity. It states, in conventionally abbreviated form, ‘(The tomb of ) Caecilia Metella, daughter of Quintus (Caecilius Metellus) Creticus, (wife of Marcus Licinius) Crassus’. It was thus primarily a monument to the family’s status and association placed in an appropriately commanding position where it still stands. Rome, "), _c('i', [_vm._v("c")]), _vm._v(". 25–1 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("3. Cleopatra VII and Caesarion")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Cleopatra VII (reigned 51–30 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(") and her son by Julius Caesar, Caesarion (Ptolemy XV, reigned 36–30 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v("), shown here as an adult. Flaunted in Rome by Caesar to aristocratic disgust in 46 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", later Roman sources routinely depicted Cleopatra as a dangerous and destabilizing woman whose influence had effeminated Mark Antony and led to his destruction. She provided a useful contrast for the Augustan state and its image of idealized women in the form of Livia and Octavia. Temple of Hathor, Dendera, Egypt, 30s "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("4. Pompeii lovers")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("A fresco panel from Pompeii depicting a man and woman in a chair. The woman plays a "), _c('i', [_vm._v("kithara")]), _vm._v(" (lyre) while her lover gazes upon and holds her. The woman’s lighter skin was a convention that indicated her status, partaking in suitably refined pastimes. "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 50–79.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("5. Theatre of Marcellus, Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Originally a project of Caesar’s, the theatre was finished by Augustus in the name of Octavia’s son Marcus Marcellus, his (likely) intended heir, but who died in 23 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(". It remains one of Rome’s most prominent ancient buildings from the Julio-Claudian period. Marcellus’ death forced Augustus to look to his daughter Julia to provide an heir.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("6. Porticus of Octavia")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("The Porticus of Octavia replaced the earlier Porticus of Metellus (an ancestor of Caecilia Metella, see plate 2) in 27–25 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", dedicated to Octavia, Augustus’ sister and the mother of Marcellus, in whose name a theatre was dedicated very close by (see plate 5). Essentially a complex of art galleries, temples, colonnades, a library and schools, only its monumental gateway survives today and even that is a Severan reconstruction.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("7. Ara Pacis, Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Panel from the Ara Pacis (‘Altar of Peace’) probably depicting Venus Genetrix, though other suggestions include Pax and Tellus (Mother Earth). Such female personifications were an essential part of the Augustan myth. Commissioned in 13 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", dedicated in 9 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("8. Agrippa and Julia, Ara Pacis, Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Panel from the north processional frieze showing Agrippa (left) with, probably, Julia (right) and between them their son, Augustus’ grandson Gaius. Commissioned in 13 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", dedicated in 9 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("9. Bust of Livia")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("A life-size marble bust of Livia made during her lifetime. Nevertheless, the features are clearly both idealized and implausibly youthful, just as statues of Augustus were. From Italy, "), _c('i', [_vm._v("c")]), _vm._v(". 25–1 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("10. Posthumous bust of Livia as the goddess Ceres")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("The image shows how Livia remained the embodiment of idealized virtues and a useful model for realizing female deities or personifications. Probably made in Sicily, "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 30–50.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("11. Clay oil lamp with a bust of Livia")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("A mid-first-century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" clay oil lamp decorated with a stylized female bust usually identified as Livia. Livia was treated as a kind of template for depicting an idealized representation of a Roman matron, though these images became increasingly distanced from reality. Probably from Pozzuoli,  "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 40–80.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("12. Building of Eumachia, Pompeii")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Eumachia, public priestess of Pompeii and wealthy businesswoman, used this building to promote the political career of her son, Marcus Numistrius Fronto, in the Augustan period. Appropriately, it paid homage to the Forum of Augustus and the Porticus of Livia and contained a shrine with a statue of Livia as Concordia Augusta. Built late in the reign of Augustus (27 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v("–"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 14) or under Tiberius ("), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 14–37).")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("13. The Mausoleum of Augustus")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Now a shadow of its former self, this vast drum-shaped mausoleum in the Field of Mars (Campus Martius) once contained the cremated remains of the Julio-Claudians, each grave marked by a marble tablet (see plate 19). It was the symbolic centre of the dynasty where the key individuals through which the succession passed were laid to rest.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("14. Dedication to the Deified Augusta (Livia), Herculaneum")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Dedication to Livia by Lucius Mammius Maximus ‘with his own money’ – a successful freedman. From the Porticus at Herculaneum. Mammius Maximus also funded monuments of other members of the imperial family which dates the series, probably  "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 50–4.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("15. Porticus of Livia, Marble Plan of Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("The Marble Plan of Rome was created during the reign of Septimius Severus and was displayed in the Flavian Temple of Peace. This section preserves the plan of the now lost Porticus of Livia dedicated in 7 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", showing that there was a temple in the centre of a piazza surrounded by a colonnade on three sides with apses. This structure was probably the inspiration for the Building of Eumachia at Pompeii (plate 12). It lay just north of the later site of the Baths of Trajan. "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 203–11.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("16. Inscription of Lucius Caesar, Porticus of Gaius and Lucius")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Honorific inscription from the Porticus of Gaius and Lucius, Julia’s sons by Agrippa, in the Forum at Rome. The text describes Lucius as the son of Augustus, and grandson of Caesar. Julia and Agrippa are unmentioned. The Porticus, which contained shops and was attached to the Basilica Paulli, was rebuilt and dedicated by Augustus. Rome, 3 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate17"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("17. Temple of Vesta, Roman Forum")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Livia attended a fire here during the reign of Tiberius and urged on soldiers and others to douse the flames. The present structure is heavily restored from what remained of a rebuilding by Julia Domna two centuries later.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("18. The Roman Forum")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("At lower left is the Temple of Vesta, and on the right the three remaining columns of the Temple of Castor and Pollux. Dedicated in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 6 by Tiberius in his name and that of his brother Drusus, this Augustan temple was originally conceived as being associated with Gaius and Lucius, Julia’s sons, but their premature deaths rendered that plan obsolete. Behind at ground level is the House of the Vestal Virgins.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("19. Tombstone of Agrippina the Elder")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Originally deposited in the Mausoleum of Augustus by Caligula who recovered his mother’s remains and brought them to Rome. The inscription makes Agrippina’s dynastic role as daughter of Agrippa, granddaughter of Augustus, wife of Germanicus and mother of Caligula crystal clear. Rome, "), _c('i', [_vm._v("c")]), _vm._v(". 37–41.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("20. Sestertius of Agrippina the Elder")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("A sestertius of Agrippina the Elder struck posthumously under Claudius, her brother-in-law. The portrait is a study in evoking her image as a heroic Roman matron of the old school and implicitly as a victim of Tiberius. Diameter 32mm. Rome, "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 42.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("21. Bronze coin of Messalina")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Bronze coin (18mm) from Aeolis, Aegae, in the name of Messalina, Claudius’ third wife and first empress. The coin unofficially gives her the Greek equivalent title of Augusta (CEBACTH), a title she never received. The reverse shows Zeus Aëtophorus standing left. Struck "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 41–8.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("22. Cistophoric tetradrachm (silver) of Claudius and Agrippina")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Jugate busts of the emperor and Agrippina the Younger. The issue is an exceptional instance of an emperor and empress depicted in the manner of joint rulers. Diameter 26mm. Ephesus, "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 51.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("23. The Gemma Claudia")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Sardonyx five-layered cameo depicting (left) Claudius and Agrippina the Younger and (right) Germanicus and Agrippina the Elder. The busts emerge from cornucopiae resting on captured military equipment with Jupiter (the eagle) in the middle. The design symbolizes the integrity of the dynasty through the combined descent from Augustus and Livia. Height 12cm. "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 49.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("24. Agrippina crowns Nero")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Sculpture from Aphrodisias showing Agrippina symbolically crowning her son Nero. Created "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 54–9.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate25"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("25. Nero’s Golden House, Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("One of the now subterranean chambers beneath the Baths of Trajan. Poppaea probably spent her last months in this remarkable complex. Rome, "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 64–8.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("26. Tetradrachm of Nero and Poppaea")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Nero and Poppaea depicted on an Egyptian tetradrachm. Diameter 24mm. Alexandria, "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 64–5.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("27. View of Oplontis")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("A view across one of the colonnaded courts of the palatial villa of Oplontis near Pompeii, probably owned by Nero and used by Poppaea. The house was extensively repaired and remodelled after the earthquake of "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 62, but was destroyed and buried in the eruption of Vesuvius in August 79.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate28.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("28. Sestertius of the Temple of the Deified Augustus and Livia")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Antoninus restored the Temple of the Deified Augustus and Livia and recorded the fact on this sestertius. Their cult statues are shown inside the temple between the two central columns in a stylistic convention. There was no such gap in reality. The temple is long lost but probably lay between the Capitoline and Palatine Hills in Rome. Diameter 32mm. Rome, "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 158–9.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate29"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate29.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("29. The Severan Women")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("From left to right: Julia Domna (d. "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 217), Septimius Severus’ empress; her sister Julia Maesa (d. "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 225); and Maesa’s daughters, Julia Soaemias (d. "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 222), mother of Elagabalus, and Julia Mamaea (d. "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 235), mother of Severus Alexander. Although the quality of coin portraiture was poor by this date the physical resemblance between the women is noticeable. The hairstyles are largely attributable to the habitual use of wigs by eastern women of high status at this time. From silver denarii struck at Rome. Diameter of each approximately 17–18mm.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate30"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate30.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("30. Julia Domna and Septimius Severus on the Arch of the Moneychangers (Porta Argentarii), Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("Domna holds a "), _c('i', [_vm._v("caduceus")]), _vm._v(" (staff of a herald) to symbolize her title ‘Mother of the Army’. The blank space to the right is where a figure of her younger son Geta was erased after his murder by Caracalla in 212, requiring her left arm to be recarved. Meanwhile Severus as "), _c('i', [_vm._v("pontifex maximus")]), _vm._v(" (chief priest) pours a libation over an altar. Dedicated "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 204.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate31.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("31. Sestertius of Julia Mamaea")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("A brass sestertius in the extensive series of coins issued in the name of Severus Alexander’s mother Julia Mamaea, the last of the Severan empresses. The reverse depicts Felicitas (‘Happiness’), a stock theme in the repertoire used by the women of the dynasty. Mamaea’s death, along with that of Severus in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 235, marked the end of the dynasty. Diameter "), _c('i', [_vm._v("c")]), _vm._v(". 30mm. Rome, "), _c('i', [_vm._v("c")]), _vm._v(". "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 228.")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "plate32"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/plate32.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate-caption"
  }, [_c('b', [_vm._v("32. Julio-Claudian dynastic relief, Ravenna")])]), _vm._v(" "), _c('p', {
    staticClass: "plate-source"
  }, [_vm._v("This relief found at Ravenna close to the so-called Tomb of Galla Placidia was designed to advertise Claudius’ dynastic credentials in which Livia played a central role. From left to right: seated female figure, perhaps Antonia Minor (mother of Claudius); a male cuirassed figure, perhaps Nero Claudius Drusus; Germanicus;  Livia as Venus with Eros on her shoulder; and the deified Augustus as Mars. Height 104cm. Created during the reign of Claudius, "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 41–54.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0269a216","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plate_section.vue
// module id = 78
// module chunks = 0